var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyRagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 11L1.33301 9L4.66634 7L7.99967 9V12.6667L4.66634 14.6667V11Z",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 9V12.6667L4.66634 14.6667",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 11.0298L7.99935 9.00977",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.02L11.3333 7",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 9.00016V5.3335L4.66699 3.3335L8.00033 1.3335L11.3337 3.3335V7.00016",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 3.35352V6.99018",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.3335L11.3333 3.3335",
    stroke: "#838FB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.306 14.2267C14.288 14.2591 14.2621 14.286 14.2309 14.3048C14.1997 14.3235 14.1643 14.3333 14.1283 14.3333H9.20493C9.16894 14.3333 9.13359 14.3234 9.10243 14.3047C9.07128 14.2859 9.04541 14.259 9.02743 14.2266C9.00945 14.1942 8.99999 14.1574 9 14.12C9.00001 14.0826 9.00949 14.0458 9.02748 14.0134C9.41802 13.3113 10.0198 12.8079 10.7222 12.5693C10.3748 12.3543 10.1049 12.0266 9.95389 11.6366C9.80292 11.2466 9.77924 10.8158 9.88649 10.4105C9.99374 10.0052 10.226 9.64762 10.5476 9.39281C10.8692 9.138 11.2623 9 11.6666 9C12.0709 9 12.464 9.138 12.7856 9.39281C13.1072 9.64762 13.3395 10.0052 13.4467 10.4105C13.554 10.8158 13.5303 11.2466 13.3793 11.6366C13.2283 12.0266 12.9584 12.3543 12.611 12.5693C13.3134 12.8079 13.9152 13.3113 14.3057 14.0134C14.3238 14.0458 14.3333 14.0826 14.3333 14.12C14.3334 14.1574 14.3239 14.1942 14.306 14.2267Z",
    fill: "#838FB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyRagIcon);
export default __webpack_public_path__ + "static/media/myRagIcon.8cb16f400d6aa78a18aac5d9ddafae05.svg";
export { ForwardRef as ReactComponent };